import React from 'react';
import Recipe from '../Recipe/Recipe';
import { Link, Route } from 'react-router-dom';
import classes from './RecipesListingPage.module.css';
import Aux from '../../../hoc/Auxiliary/Auxiliary';

const recipesListingPage = (props) => {
	const recipes = props.dataRecipes.map(recipe => {
		return (
			<li key={recipe.slug} className={classes.RecipesListing}>
				<Link
					className={classes.Recipe}
					to={`/recipes/${recipe.type}/${recipe.slug}`}
				>
				<Recipe
					data={recipe}
					listingRecipes={true}
					className={classes.ListingTitle}
				/>
				</Link>
			</li>
		);
	});
	
	return (
		<Aux>
			{recipes}
		</Aux>
	)
}

export default recipesListingPage;